var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-view',{key:'department-' + _vm.$route.fullPath}),_vm._v(" "),(_vm.viewDepartment)?_c('view-department-component'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }